import { FC } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import ArrowBackButton from '../../../../components/ArrowBack';

import VolumeButton from '../../../../components/Volume';
import RulesButton from '../../../../components/RulesButton';

type TDifficultyHeaderProps = {
  className?: string;
};

const DifficultyHeader: FC<TDifficultyHeaderProps> = ({ className }) => {
  return (
    <div className={classNames(styles.difficultyHeader, className)}>
      <ArrowBackButton className={styles.arrowBack} />

      <div className={styles.buttons}>
        <VolumeButton />
        <RulesButton />
      </div>
    </div>
  );
};

export default DifficultyHeader;
